import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useToast } from "../../Utils/toastContext";

const InvestorDetailPopup = ({ investmentID, onClose }) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const [comments, setComments] = useState("");
  const [portfolioDataAvailable, setportfolioDataAvailable] = useState(false);
  const [portfolioData, setPortfolioData] = useState([]);
  const [commentData, setCommentData] = useState([]);
  const [popupData, setPopupData] = useState([]);
  const [popupDataTable, setPopupDataTable] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();
  const formatDateTime = (dateString) => {
    const [datePart, timePart, meridian, timezone] = dateString.split(" ");
    const [day, month, year] = datePart.split("/");
    const [hours, minutes] = timePart.split(":");

    // Convert 24-hour format to 12-hour format
    const hours12 = (+hours % 12 || 12).toString();
    const formattedTime = `${hours12}.${minutes}${meridian}`;
    return `${formattedTime} | ${day}/${month}/${year}`;
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getCommentData = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/investment-portfolio/${investmentID}/comments`
      );
      if (response.status == 200) {
        if (response.data.length > 0) {
          setCommentData(response.data);
        } else {
          setCommentData([]);
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setCommentData([]);
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getPopData = async () => {
    setIsLoading(true);
    try {
      const response = await GetAPIcalls(
        `/v1/investment-request/${investmentID}/pop-up`
      );
      if (response.status == 200) {
        setPopupData(response.data);
        setPopupDataTable(response.data.categories.portfolio_breakdown);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setPopupData([]);
          setPopupDataTable([]);
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  useEffect(() => {
    getCommentData();
    getPopData();
  }, []);
  const AddCommentAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/investment-portfolio/add-comment/${investmentID}`;
    const bodyData = {
      comment: comments,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const AddComment = async (e) => {
    // e.preventDefault();
    try {
      const response = await AddCommentAPI();

      if (response.status == 201) {
        getCommentData();
        setComments("");
      } else {
        showToast(response.message, "error");
      }
    } catch (err) {
      showToast(err.message, "error");
    }
  };
  return (
    <div className="fixed inset-0 flex py-2 items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white max-h-[90vh]  overflow-y-auto rounded-md shadow-lg p-6 w-[90%] max-w-4xl relative">
        {/* Popup Header */}
        <button
          onClick={onClose}
          className="absolute top-4 rounded-full right-4 font-medium px-2 py-1"
        >
          <img src="/add.svg" alt="Close" className="w-10 h-10" />
        </button>
        <div className="text-center mb-6">
          <h2 className="text-lg font-medium">{popupData.investor_name}</h2>
        </div>
        {/* Main Grid with Left and Right Sections */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Left Section - Document Information */}
          <div>
            <label className="block text-sm text-labelLightColour font-medium">
              Investment Amount
            </label>
            <input
              type="text"
              name="documentId"
              value={
                popupData?.investment_amount
                  ? popupData.investment_amount
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  : "0.00"
              }
              disabled
              className="w-full bg-white text-black rounded-xl px-1 py-2 mb-4"
              placeholder="DXXXX"
            />
            <label className="block text-sm text-labelLightColour font-medium">
              Balance
            </label>
            <input
              type="text"
              name="documentId"
              value={
                popupData?.cash_account_balance
                  ? popupData.cash_account_balance
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  : "0.00"
              }
              disabled
              className="w-full bg-white text-black rounded-xl px-1 py-2 mb-4"
              placeholder="DXXXX"
            />
            <label className="block text-sm text-labelLightColour font-medium">
              Hold
            </label>
            <input
              type="text"
              name="holding amount"
              value={
                popupData?.holding_amount
                  ? popupData.holding_amount
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  : "0.00"
              }
              disabled
              className="w-full bg-white text-black rounded-xl px-1 py-2 mb-4"
              placeholder="DXXXX"
            />
          </div>

          {/* Right Section - Upload Document */}
          <div>
            <label className="block text-sm text-labelLightColour font-medium">
              Investment Name
            </label>
            <input
              type="text"
              name="documentId"
              value={popupData.investment_product_name}
              disabled
              className="w-full bg-white text-black rounded-xl px-1 py-2 mb-4"
              placeholder="DXXXX"
            />
            <label className="block text-sm text-labelLightColour font-medium">
              Status
            </label>
            <input
              type="text"
              name="documentId"
              value={popupData.investment_status}
              disabled
              className="w-full bg-white text-black rounded-xl px-1 py-2 mb-4"
              placeholder="Investment name"
            />
          </div>
          <div className="mb-2">
            {/* Label */}
            <label className="block text-sm text-labelLightColour font-medium mb-1">
              Comments
            </label>

            {/* Textarea with Button */}
            <div className="flex text-sm items-center">
              <textarea
                type="text"
                name="documentId"
                value={comments}
                onChange={(e) => setComments(e.target.value)}
                className="w-full resize-none bg-white text-black rounded-xl px-3 py-2"
                placeholder="Add your comments"
              />
              <button
                // Replace with your actual function
                onClick={AddComment}
                className="ml-2 bg-black text-lg text-white px-4 py-2 rounded-lg hover:bg-black"
              >
                +
              </button>
            </div>
          </div>
        </div>
        <div className="space-y-4 mt-4 w-full">
          {/* <div
              key={1}
              className={`p-4 rounded-md ${
                index % 2 === 0 ? "bg-blue-50" : "bg-gray-50"
              }`}
            > */}
          {commentData.map((comment) => (
            <div key={1} className={`p-4 rounded-md bg-blue-50`}>
              <div className="flex items-center">
                {/* User Avatar */}
                <div className="h-10 w-10 rounded-full bg-gray-300 flex-shrink-0">
                  <img
                    src="/avatar.svg"
                    alt="Close Icon"
                    className="h-10 w-10"
                  />
                </div>

                {/* Content */}
                <div className="ml-4">
                  <p className="text-sm flex flex-wrap items-center">
                    <span className="text-[#8C8C8C]">Comment added by</span>{" "}
                    <span className="font-medium ml-1">
                      {comment.user.first_name} {comment.user.last_name}
                    </span>{" "}
                    <span className="font-medium ml-1 text-blue-600">
                      {comment.user.role}
                    </span>{" "}
                    <span className="text-[#8C8C8C] ml-1">at</span>{" "}
                    <span className="text-xs text-gray-500 flex items-center ml-1 mt-0 sm:mt-0 sm:flex-nowrap">
                      {/* Time Icon */}
                      <img
                        src="/backward-10-seconds.svg"
                        alt="Time Icon"
                        className="h-4 w-4 mr-1"
                      />
                      <span>{formatDateTime(comment.created_at)}</span>
                    </span>
                  </p>

                  <p className="text-xs mt-2 text-gray-500 flex items-center space-x-2">
                    <span>{comment.comment}</span>
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
        {popupDataTable && (
          <div className="overflow-x-auto mt-4">
            <table className="table-auto border-collapse w-full text-sm">
              <thead>
                <tr className="bg-[#6AA7D3] text-white font-semibold">
                  <th className="border border-white  px-4 py-2">No</th>
                  <th className="border border-white  px-4 py-2">
                    Strategic Asset Allocation
                  </th>
                  <th className="border border-white  px-4 py-2">Code</th>
                  <th className="border border-white  px-4 py-2">SAA</th>
                  <th className="border border-white  px-4 py-2">Capital</th>
                  <th className="border bg-[#F4D580]  border-white  px-4 py-2">
                    Market Price
                  </th>
                  <th className="border border-white  px-4 py-2">Shares</th>
                  <th className="border border-white  px-4 py-2">Value ($)</th>
                  <th className="border border-white  px-4 py-2">Brokerage</th>
                </tr>
              </thead>
              {isLoading ? (
                <tbody className="shimmer-container-list ">
                  {/* Creating 5 rows of shimmer effect */}
                  {[...Array(5)].map((_, rowIndex) => (
                    <tr key={rowIndex} className="shimmer-row-list">
                      {/* Creating 7 cells in each row for shimmer */}
                      {[...Array(7)].map((_, colIndex) => (
                        <td key={colIndex} className="shimmer-cell-list">
                          <div className="shimmer-loader"></div>
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody>
                  {popupDataTable.map((categoryData, categoryIndex) => (
                    <React.Fragment key={categoryIndex}>
                      {/* Category Row */}
                      <tr
                        className={`px-6 py-2 rounded-lg ${
                          categoryData.category.name.toUpperCase() == "GROWTH"
                            ? "bg-[#92C5EA]"
                            : "bg-[#A9D4AB]"
                        }`}
                      >
                        <td
                          colSpan={1}
                          className="border border-white px-4 py-2 font-bold"
                        ></td>
                        <td
                          colSpan={1}
                          className="border border-white px-4 py-2 font-bold"
                        >
                          {categoryData.category.name.toUpperCase()}
                        </td>
                        <td
                          colSpan={1}
                          className="border border-white  px-4 py-2 font-bold"
                        ></td>
                        <td
                          colSpan={1}
                          className="border border-white px-4 py-2 font-bold"
                        ></td>
                        <td
                          colSpan={1}
                          className="border border-white px-4 py-2 font-bold"
                        ></td>
                        <td
                          colSpan={1}
                          className="border border-white bg-[#F4D580]  px-4 py-2 font-bold"
                        ></td>
                        <td
                          colSpan={1}
                          className={`border border-white px-4 py-2 font-bold ${
                            categoryData.category.name.toUpperCase() == "GROWTH"
                              ? ""
                              : "bg-[#F8C5C5]"
                          }`}
                        ></td>
                        <td
                          colSpan={1}
                          className="border border-white px-4 py-2 font-bold"
                        ></td>
                        <td
                          colSpan={1}
                          className="border border-white px-4 py-2 font-bold"
                        ></td>
                      </tr>

                      {/* Products */}
                      {categoryData.category.products.map(
                        (product, productIndex) => (
                          <React.Fragment key={productIndex}>
                            {/* Product Row */}
                            <tr
                              className={`text-[#005A9C] ${
                                categoryData.category.name.toUpperCase() ==
                                "GROWTH"
                                  ? "bg-[#C6DFF1]"
                                  : "bg-[#C0E2C1]"
                              }`}
                            >
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-bold"
                              >
                                {(productIndex + 1).toString().padStart(2, "0")}
                              </td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-semibold"
                              >
                                {product.name}
                              </td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-semibold"
                              ></td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-bold"
                              >
                                {product.allocation
                                  .toFixed(2)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                %
                              </td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-bold"
                              >
                                {product.capital
                                  .toFixed(2)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"}
                              </td>
                              <td
                                colSpan={1}
                                className="border border-white bg-[#F4D580] px-4 py-2 font-bold"
                              ></td>
                              <td
                                colSpan={1}
                                className="border border-white bg-[#F8C5C5] px-4 py-2 font-bold"
                              ></td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-bold"
                              ></td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-bold"
                              ></td>
                            </tr>

                            {/* Stocks */}
                            {product.stocks.map((stock, stockIndex) => (
                              <tr
                                key={stockIndex}
                                className={`text-[#black] ${
                                  categoryData.category.name.toUpperCase() ==
                                  "GROWTH"
                                    ? "bg-[#E6F3FC]"
                                    : "bg-[#E7F5E8]"
                                }`}
                              >
                                <td className="border border-white px-4 py-2"></td>
                                <td className="border border-white px-4 py-2">
                                  {stock.name}
                                </td>
                                <td className="border border-white px-4 py-2">
                                  {stock.asx_code}
                                </td>
                                <td className="border border-white px-4 py-2">
                                  {stock.allocation.toFixed(2)}%{" "}
                                  {!stock.allocation ? "-" : ""}
                                </td>
                                <td className="border border-white px-4 py-2">
                                  {stock.capital
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",") ||
                                    "-"}
                                </td>
                                <td className="border border-white bg-[#F4D580]  px-4 py-2">
                                  {stock.market_value
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",") ||
                                    "-"}
                                </td>
                                <td className="border border-white bg-[#F8C5C5] px-4 py-2">
                                  {!stock.quantity
                                    ? "00"
                                    : stock.quantity
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </td>
                                <td className="border border-white px-4 py-2">
                                  {stock.market_value
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",") ||
                                    "-"}
                                </td>
                                <td className="border border-white px-4 py-2">
                                  {!stock.brokerage_fee
                                    ? "-"
                                    : stock.brokerage_fee.toFixed(2)}
                                </td>
                              </tr>
                            ))}
                          </React.Fragment>
                        )
                      )}
                      <tr
                        className={`font-bold ${
                          categoryData.category.name.toUpperCase() == "GROWTH"
                            ? "bg-[#92C5EA]"
                            : "bg-[#A9D4AB]"
                        }`}
                      >
                        <td colSpan={1} className="border px-4 py-2"></td>
                        <td colSpan={2} className="border px-4 py-2">
                          SUB-TOTAL {categoryData.category.name}
                        </td>
                        <td colSpan={1} className="border px-4 py-2">
                          {categoryData.category.allocation.toFixed(2)}%
                        </td>
                        <td colSpan={1} className="border px-4 py-2">
                          {categoryData.category.capital
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"}
                        </td>
                        <td
                          colSpan={1}
                          className="border bg-[#F4D580]  px-4 py-2"
                        ></td>
                        <td
                          colSpan={1}
                          className={`border px-4 py-2 ${
                            categoryData.category.name.toUpperCase() == "GROWTH"
                              ? "bg-[#F8C5C5]"
                              : ""
                          }`}
                        ></td>
                        <td colSpan={1} className="border px-4 py-2 text-right">
                          {categoryData.category.market_value
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"}
                        </td>
                        <td
                          colSpan={1}
                          className="border px-4 py-2 text-right"
                        ></td>
                      </tr>

                      {categoryData.category.name.toUpperCase() == "GROWTH" && (
                        <tr className="bg-[#EAEAEA] font-bold">
                          <td
                            colSpan={1}
                            className="border px-4 py-2 text-right"
                          ></td>
                          <td colSpan={2} className="border px-4 py-2"></td>
                          <td colSpan={1} className="border px-4 py-2"></td>
                          <td colSpan={1} className="border px-4 py-2"></td>
                          <td
                            colSpan={1}
                            className="border   px-4 py-2 text-right"
                          ></td>
                          <td
                            colSpan={1}
                            className="border px-4 py-2 text-right"
                          ></td>
                          <td
                            colSpan={1}
                            className="border px-4 py-2 text-right"
                          ></td>
                          <td
                            colSpan={1}
                            className="border px-4 py-2 text-right"
                          ></td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                  <React.Fragment>
                    <tr className="bg-[#EAEAEA] font-bold">
                      <td
                        colSpan={1}
                        className="border px-4 py-2 text-right"
                      ></td>
                      <td colSpan={2} className="border px-4 py-2">
                        Summary
                      </td>
                      <td colSpan={1} className="border px-4 py-2"></td>
                      <td colSpan={1} className="border px-4 py-2"></td>
                      <td
                        colSpan={1}
                        className="border bg-[#F4D580]  px-4 py-2 text-right"
                      ></td>
                      <td
                        colSpan={1}
                        className="border px-4 py-2 text-right"
                      ></td>
                      <td
                        colSpan={1}
                        className="border px-4 py-2 text-right"
                      ></td>
                      <td
                        colSpan={1}
                        className="border px-4 py-2 text-right"
                      ></td>
                    </tr>
                    <tr className="bg-[#92C5EA]  font-bold">
                      <td
                        colSpan={1}
                        className="border px-4 py-2 text-right"
                      ></td>
                      <td colSpan={2} className="border px-4 py-2">
                        {popupDataTable[0].category.name}
                      </td>
                      <td colSpan={1} className="border px-4 py-2">
                        {popupDataTable[0].category.allocation.toFixed(2)}%
                      </td>
                      <td colSpan={1} className="border px-4 py-2">
                        {popupDataTable[0].category.capital
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"}
                      </td>
                      <td
                        colSpan={1}
                        className="border bg-[#F4D580]  px-4 py-2"
                      ></td>
                      <td colSpan={1} className="border px-4 py-2"></td>
                      <td colSpan={1} className="border px-4 py-2">
                        {popupDataTable[0].category.market_value
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"}
                      </td>
                      <td colSpan={1} className="border px-4 py-2 ">
                        {popupDataTable[0].category.category_brokerage_fee ||
                          "-"}
                      </td>
                    </tr>
                    <tr className="bg-[#A9D4AB] font-bold">
                      <td colSpan={1} className="border px-4 py-2 "></td>
                      <td colSpan={2} className="border px-4 py-2">
                        {popupDataTable[1].category.name}
                      </td>
                      <td colSpan={1} className="border px-4 py-2">
                        {popupDataTable[1].category.allocation.toFixed(2)}%
                      </td>
                      <td colSpan={1} className="border px-4 py-2">
                        {popupDataTable[1].category.capital
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"}
                      </td>
                      <td
                        colSpan={1}
                        className="border bg-[#F4D580]  px-4 py-2 text-right"
                      ></td>
                      <td colSpan={1} className="border px-4 py-2"></td>
                      <td colSpan={1} className="border px-4 py-2">
                        {popupDataTable[1].category.market_value.toFixed(2) ||
                          "-"}
                      </td>
                      <td colSpan={1} className="border px-4 py-2">
                        {popupDataTable[1].category.category_brokerage_fee ||
                          "-"}
                      </td>
                    </tr>
                    <tr className="bg-[#CDCDCD] font-bold">
                      <td colSpan={1} className="border px-4 py-2"></td>
                      <td colSpan={2} className="border px-4 py-2">
                        TOTAL PORTFOLIO
                      </td>
                      <td colSpan={1} className="border px-4 py-2">
                        {(
                          popupDataTable[0].category.allocation +
                          popupDataTable[1].category.allocation
                        ).toFixed(2) + "%" || "-"}
                      </td>
                      <td colSpan={1} className="border px-4 py-2">
                        {(
                          popupDataTable[0].category.capital +
                          popupDataTable[1].category.capital
                        )
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"}
                      </td>
                      <td
                        colSpan={1}
                        className="border bg-[#F4D580]  px-4 py-2"
                      ></td>
                      <td colSpan={1} className="border px-4 py-2"></td>
                      <td colSpan={1} className="border px-4 py-2">
                        {(
                          popupDataTable[0].category.market_value +
                          popupDataTable[1].category.market_value
                        )
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"}
                      </td>
                      <td colSpan={1} className="border px-4 py-2">
                        {" "}
                        {(
                          popupDataTable[0].category.category_brokerage_fee +
                          popupDataTable[1].category.category_brokerage_fee
                        ).toFixed(2) || "-"}
                      </td>
                    </tr>
                  </React.Fragment>
                </tbody>
              )}
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default InvestorDetailPopup;
